/* eslint-disable react/jsx-no-undef */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
// import { CircularProgress } from "@material-ui/core";
import React from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_helpers";


export function WidgetForMasterUser({ className, totalMasterUsers, newTotalUsers }) {
    return (
        <div className={`card card-custom   ${className}`}>


            {/* Body */}
            <div className="rounded   ">
                {/* Stat */}
                <div className="card-spacer ">
                    <div className="row ml-3 ">
                        <div className="col-sm-3 shadow bg-light-primary px-6 py-8 rounded mr-7 mb-2">
                            <span className="svg-icon svg-icon-3x svg-icon-primary d-block my-2">
                                <SVG
                                    src={toAbsoluteUrl("/media/svg/icons/General/User.svg")}
                                ></SVG><span className="text-primary float-right font-weight-bold font-size-h1 mr-5">{totalMasterUsers}</span>
                            </span>
                            <p className="text-primary font-weight-bold font-size-h6" >
                                Total Users        </p>
                        </div>

                        <div className="col-sm-3 shadow  bg-light-success px-6 py-8 rounded   mb-2">
                            <span className="svg-icon svg-icon-3x svg-icon-success d-block my-2">
                                <SVG
                                    src={toAbsoluteUrl(
                                        "/media/svg/icons/Communication/Add-user.svg"
                                    )}
                                ></SVG><span className="text-success float-right font-weight-bold font-size-h1 mr-5">{newTotalUsers}</span>
                            </span>
                            <p className="text-success font-weight-bold font-size-h6 mt-2" >
                                New Users </p>
                        </div>
                    </div>
                    <div className="row m-0">

                    </div>
                </div>

                {/* Resize */}
                <div className="resize-triggers">
                    <div className="expand-trigger">
                        <div style={{ width: "411px", height: "461px" }} />
                    </div>
                    <div className="contract-trigger" />
                </div>
            </div>
        </div>
    )

}
